import { http, setFormData } from '@/utils/http'
import { FETCH_CATEGORY, CREATE_CATEGORY, UPDATE_CATEGORY } from '@/store/actions/category'

const state = {
  aidCategories: [],
  beneficiaryCategories: []
}

const getters = {
  categories: state => type => state[type + 'Categories'],
  categoriesAsOptions: state => (type, sectorId) => { // aid, beneficiary
    let categories = state[type + 'Categories'].filter(
      category => category.status === 'active'
    )
    // If aid category, filter by sectore
    if (type === 'aid') {
      categories = state[type + 'Categories'].filter(
        category => category.sector_id === sectorId
      )
    }
    categories = categories.sort((a, b) => {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    })
    return categories.map(
      category => ({ text: category.name, value: category._id })
    )
  },
  categoryName: state => (type, id) => { // get category name by id
    const category = state[type + 'Categories'].find(category => category._id === id)
    return category !== undefined ? category.name : ''
  } 
}

const mutations = {
  [FETCH_CATEGORY]: (state, payload) => {
    state[payload.type + 'Categories'] = [ ...payload.data ]
  },
  [UPDATE_CATEGORY]: (state, payload) => {
    const updatedcategorys = state[payload.type + 'Categories'].map(category => {
      return category._id === payload.data._id ? Object.assign(category, payload.data) : category
    })
    state[payload.type + 'Categories'] = updatedcategorys
  }
}

const actions = {
  [FETCH_CATEGORY]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      http.get(payload.model + '/read_all')
        .then(({ data: response }) => {
          if (response.code === 200) {
            commit(FETCH_CATEGORY, { 
              type: payload.model === 'category' ? 'aid' : 'beneficiary', 
              data: response.data 
            })
            resolve(response)
          }
          else {
            reject(response)
          }
        })
    })
  },
  [CREATE_CATEGORY]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const params = setFormData(payload.data)
      http.post(payload.model + '/create', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            resolve(response)
          }
          else {
            reject(response)
          }
        })
    })
  },
  [UPDATE_CATEGORY]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const params = setFormData(payload.data)
      http.post(payload.model + '/update', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            commit(UPDATE_CATEGORY, { 
              type: payload.model === 'category' ? 'aid' : 'beneficiary', 
              data: payload.data 
            })
            resolve(response)
          }
          else {
            reject(response)
          }
        })
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
